PLA.a11y = {};

PLA.a11y.keys = {
	tab  : 9,
	enter: 13,
	esc  : 27,
	space: 32,
	left : 37,
	up   : 38,
	right: 39,
	down : 40
};

PLA.a11y.revealScreenReaderText = function() {
	var $ = jqPla;

	$( '.screen-reader-only' ).css( {
		border  : '2px solid blue',
		clip    : 'auto',
		height  : 'auto',
		margin  : 0,
		overflow: 'visible',
		padding : 5,
		position: 'static',
		width   : 'auto',

		background: 'red',
		color     : 'white'
	} );

	// Special exception:
	$('.coin-vedettes-grid').find('.screen-reader-only').css({
		fontSize: 12
	});
}

PLA.a11y.addScreenReaderRevealButton = {
	init: function () {
		var $ = jqPla,
			_this = PLA.a11y.addScreenReaderRevealButton;

		_this.$btnSr = $( '.pla-screen-reader-button' );

		if ( _this.$btnSr.length < 1 ) {
			return;
		}

		_this.bindEvents();


	},

	bindEvents: function () {
		var $ = jqPla,
			_this = PLA.a11y.addScreenReaderRevealButton;

		_this.$btnSr.one( 'click', function ( e ) {
			PLA.a11y.revealScreenReaderText();
			//console.log( '[PLA.a11y] Showing .screen-reader-only text.' );
			$( this ).addClass( 'disabled' );
		} );
	}
}

;